// ActivityRedirect.jsx
// Redirects old numeric ID routes (/activities/:id/) to slug-based routes (/activities/:slug/)
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';

export default function ActivityRedirect() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Only redirect if id is numeric (matches pattern like "22", "123", etc.)
    // If it's not numeric, it's likely a slug that doesn't match any specific route
    // In that case, let React Router handle it (will fall through to 404)
    const numericId = parseInt(id, 10);
    if (isNaN(numericId) || id !== String(numericId)) {
      // Not a numeric ID (could be a slug), redirect to activities list
      // This handles cases where someone uses an old numeric ID route format
      navigate('/', { replace: true });
      return;  
    }  

    // Fetch activity to get slug
    api.get(`/api/activities/${numericId}/`) 
      .then(response => {
        const activity = response.data;
        // Get slug-based route
        let route = activity.route;
        if (!route || /^\/activities\/\d+\/?/.test(route)) {
          // Route is missing or numeric ID-based, generate from slug
          const slugify = (s = "") => String(s).toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
          const slug = activity.slug || slugify(activity.title || activity.name || "activity");
          route = `/activities/${slug}`;
        }
        // Redirect to slug-based route
        navigate(route, { replace: true });
      })
      .catch(error => {
        console.error('Failed to fetch activity for redirect:', error);
        // If activity not found, redirect to activities list
        navigate('/', { replace: true });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id, navigate]);

  if (loading) {
    return <div>Redirecting...</div>;
  }

  return null;
}

